export default {
  title: "Tauren",
  content: [
    "New ability: Brawn: Increases critical strike damage and healing by 5%.",
  ],
};
